import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useSetDraftDatasetStateFromDataset = (userToken: string) =>
  useMutation(
    ({ datasetId }: { datasetId: number }) =>
      fetch(ENDPOINTS.draft_dataset_state_from_dataset, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          dataset_id: datasetId,
        }),
      }).then(handleResponse),
    {
      onSuccess: data =>
        // Don't invalidate queries immediately since the processing happens async
        // The websocket completion message will trigger the invalidation
        data,
    },
  );
